import { createSlice } from "@reduxjs/toolkit";

const initialDeviceLogsState = {
  siteFilterName: "",
  laneFilterName: "",
  deviceFilterName: "",
  deviceIdentifierFilterName: "",
  locationFilterName: "",
  locationFilterId: "",
  selectedSiteDataRedux: [],
  startDateRedux: "",
  endDateRedux: "",
};

const deviceLogsSlice = createSlice({
  name: "deviceLogs",
  initialState: initialDeviceLogsState,
  reducers: {
    siteFilterNameHandler(state, action) {
      state.siteFilterName = action.payload;
    },
    laneFilterNameHandler(state, action) {
      state.laneFilterName = action.payload;
    },

    deviceFilterNameHandler(state, action) {
      state.deviceFilterName = action.payload;
    },

    deviceIdentifierFilterNameHandler(state, action) {
      state.deviceIdentifierFilterName = action.payload;
    },

    locationFilterNameHandler(state, action) {
      state.locationFilterName = action.payload;
    },

    locationFilterIdHandler(state, action) {
      state.locationFilterId = action.payload;
    },

    selectedSiteDataHandler(state, action) {
      state.selectedSiteDataRedux = action.payload;
    },

    startDateHandler(state, action) {
      state.startDateRedux = action.payload;
    },

    endDateHandler(state, action) {
      state.endDateRedux = action.payload;
    },
    clearFiltersHandler(state) {
      state.siteFilterName = "";
      state.laneFilterName = "";
      state.deviceFilterName = "";
      state.deviceIdentifierFilterName = "";
      state.locationFilterName = "";
      state.selectedSiteDataRedux = [];
      state.startDateRedux = "";
      state.endDateRedux = "";
    },
  },
});

export const deviceLogsActions = deviceLogsSlice.actions;
export default deviceLogsSlice.reducer;
